import Typography from "@mui/material/Typography";

import Layout from "components/Layout";
import CustomLink from "components/CustomLink";

const PrivacyPage = () => {
  return (
    <Layout>
      <Typography component="h3" variant="h3" paragraph>
        PRIVACY POLICY
      </Typography>
      <Typography paragraph>
        Uniqly INC.,{" "}
        <b>
          1033 NE 95TH ST 33138-2547 MIAMI SHORES registry code: EIN: 92-2123574
        </b>{" "}
        (later referred to as: UNIQLY or Administrator) is the administrator of
        your Personal Data.
      </Typography>
      <Typography paragraph>
        We ask you to read the content of this Privacy Policy. If you have any
        questions related to this Privacy Policy or to submit a request for
        Personal Data, you can contact us via email at contact@uniqly.io or
        write to us at the following address: Uniqly INC.,{" "}
        <b>1033 NE 95TH ST 33138-2547 MIAMI SHORES</b>. UNIQLY is responsible
        for processing data on this website.
      </Typography>
      <Typography paragraph>
        Administrator cares of the protection of your personal data and User’s
        privacy, who visits the Website. Your personal data are collected and
        processed through our site in compliance with REGULATION (EU) 2016/679
        OF THE EUROPEAN PARLIAMENT AND OF THE COUNCILof 27 April 2016on the
        protection of natural persons with regard to the processing of personal
        data and on the free movement of such data, and repealing Directive
        95/46/EC (General Data Protection Regulation)(later referred to as:
        GDPR).
      </Typography>
      <Typography paragraph>
        Administrator is responsible for using information about you in a safe
        manner, in accordance with applicable law, in particular in accordance
        with the provisions of the GDPR and in accordance with the Regulations.
      </Typography>
      <Typography component="h4" variant="h4" paragraph>
        YOUR PERSONAL DATA ARE PROCESSED THROUGH ADMINISTRATOR IN ORDER TO:
      </Typography>
      <Typography component="div">
        <ol>
          <li>
            receive commercial information for marketing purposes, if the user
            agrees to process personal data for such purpose,
          </li>
          <li>
            perform the order or to take action before its implementation, if
            the user agrees to process personal data for such purpose,
          </li>
          <li>fulfill legal obligations,</li>
          <li>analyze data to match the offer,</li>
          <li>
            ensure the proper display of the Website on the device used by the
            User, adapting the content of the Website to the preferences of
            Users and its continuous optimization, including the use of Google
            Analytics, as well as ensuring the continuity of the User's session.
          </li>
        </ol>
      </Typography>
      <Typography component="h4" variant="h4" paragraph>
        UNIQLY may process and store following personal data:
      </Typography>
      <Typography component="div">
        <ol>
          <li>Full name of the User</li>
          <li>Telephone number</li>
          <li>Email address</li>
          <li>country in which the User resides</li>
          <li>Residential address of the User</li>
          <li>Digital wallet address</li>
        </ol>
      </Typography>
      <Typography component="h4" variant="h4" paragraph>
        WEBSITE
      </Typography>
      <Typography paragraph>
        To ensure that all necessary steps are taken to protect the privacy of
        our Users, UNIQLY created this policy in such a way that it fully
        complies with the GDPR Act. The data collected by us may be transferred
        to, and stored at, a destination outside the EU through third-party
        service providers such as Google Cloud Platform, Google Analytics, AWS
        and Mailchimp, all of which have privacy certifications.
      </Typography>
      <Typography component="h4" variant="h4" paragraph>
        LEGAL BASIS FOR THE PROCESSING OF PERSONAL DATA
      </Typography>
      <Typography component="div">
        <ol>
          <li>
            Art. 6 sec. 1a{")"} GDPR: based on an explicit and voluntary
            consent, personal data is processed for marketing purposes.
          </li>
          <li>
            Art. 6 sec. 1b{")"} GDPR: processing is necessary to perform the
            ordered to take action before its implementation.
          </li>
          <li>
            Art. 6 sec. 1c{")"} GDPR: processing is necessary to fulfill legal
            obligations.
          </li>
          <li>
            Art. 6 sec. 1f{")"} GDPR: processing is necessary for purposes
            resulting from the legitimate interest of data analysis in order to
            match the offer.
          </li>
          <li>
            Art. 6 sec. 1f{")"} GDPR: processing is necessary for purposes:
            resulting from display of the Website on the User’s device, adapting
            the content of Website to user preferences and its continuous
            optimization, including the use of Google Analytics, as well as
            ensuring the continuity of the User's session.
          </li>
        </ol>
      </Typography>
      <Typography paragraph>
        The recipients of the User’s personal data are suppliers of goods and
        services necessary for the implementation of the above-mentioned
        purposes and entities entrusted with the processing of the User's
        personal data by Administrator. With regard to the processing of the
        User’s personal data for statistical purposes, the recipient of his data
        is Google Inc. based in the USA.
      </Typography>
      <Typography paragraph>
        The recipients of the User’s personal data may be located in the
        countries outside of the European Union and European Economic Area. The
        Administrator introduces proper procedures and legal measures to ensure
        the highest level of security of the data processed by the business
        partners of the Administrator located in the countries not belonging to
        the European Union or European Economic Area.
      </Typography>
      <Typography component="h4" variant="h4" paragraph>
        PERSONAL DATA WILL BE STORED:
      </Typography>
      <Typography component="div">
        <ol>
          <li>
            in the case of data processed on the basis of consent –until
            withdrawal of the permission given by the user,
          </li>
          <li>
            in the case of personal data processed in connection with the
            legitimate interest of Administrator-until the legitimate interests
            of Administrator that constitute the basis for this processing are
            fulfilled or until an objection to such processing is raised,
          </li>
          <li>
            The data used for statistical purposes by Google Analytics is stored
            in accordance with the privacy policy of Google Inc.,
          </li>
          <li>
            UNIQLY may use external programs or applications to process the data
            presenting the activities of the User during the usage of the
            website. The Provider is entitled to chose, at his own discretion
            the appropriate software solutions enabling the Provider to follow
            the uses activity and collect statistical information of the
            activity of the Users of the website. The provider uses HOTJAR (
            <CustomLink
              href="https://www.hotjar.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.hotjar.com
            </CustomLink>
            ) to monitor the behavior of the Users during the usage of the
            website.
          </li>
        </ol>
      </Typography>
      <Typography paragraph>
        Users has the right to change or withdrawal of the permission to the
        right of access to their content against (without affecting the
        lawfulness of processing based on consent before its withdrawal)-in the
        case of processing personal data on the basis of consent, and the right
        to access their content, as well as the right to correct, delete, limit
        processing and the right to object to processing. The user also has the
        right to lodge a complaint with the supervisory body -the President of
        the Office for Personal Data Protection.
      </Typography>
      <Typography paragraph>
        If you wish to implement your rights, please contact us in the
        traditional form or via email, using the following information:
      </Typography>
      <Typography component="div">
        <ol>
          <li>
            Uniqly INC. 1033 NE 95TH ST 33138-2547 MIAMI SHORES registry code:
            EIN: 92-2123574
          </li>
          <li>contact@uniqly.io.</li>
        </ol>
      </Typography>
      <Typography component="h4" variant="h4" paragraph>
        USE OF COOKIES
      </Typography>
      <Typography paragraph>
        To make the overall users experience better, UNIQLY may collect data
        through cookie files. Where applicable, a user will be in charge of
        allowance of the use of cookies on their computer/device by the means of
        our cookie control system. This complies with recent legal requirements
        of obtaining explicit consent from users before storing and/or reading
        files such as cookies on a user’s computer/device. Cookies are small
        files invented to track, save and store information about usage of the
        website and user’s interaction on it that are saved to the user’s
        computer. Collecting this data provides the users quality experience
        within this website. UNIQLY uses the session cookies only which means
        that the cookies are temporarily use to provide the services and are
        necessary to provide the services with the highest quality.
      </Typography>
      <Typography paragraph>
        Users are advised that in order to deny the use and saving of cookies
        from this website on to their computer’s hard drive they should take
        necessary steps, such as blocking all cookie files from this website in
        their browser’s security settings. This website uses tracking software
        to collect data about how users use our services. This software is
        provided by Google Analytics, which may use cookies to track visitor
        usage. For further information, read Google’s privacy policy at{" "}
        <CustomLink
          href="http://www.google.com/privacy.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          http://www.google.com/privacy.html
        </CustomLink>
        .
      </Typography>
      <Typography component="h4" variant="h4" paragraph>
        Automatic Data Collection Technologies
      </Typography>
      <Typography paragraph>
        UNIQLY may use automatic data collection technologies to collect certain
        information about our Users equipment, browsing actions, and patterns,
        including:
      </Typography>
      <Typography paragraph>
        Details of visits to our Website, including traffic data, geolocation
        data, logs, and other communication data and the resources that our
        Users access and use on UNIQLY Website Information about computer and
        internet connection, including our Users IP address, operating system,
        and browser type.
      </Typography>
      <Typography paragraph>
        The information UNIQLY collects automatically is statistical data and
        may include personal information, or we may maintain it or associate it
        with personal information UNIQLY collects in other ways.
      </Typography>
      <Typography paragraph>
        The technologies UNIQLY uses for this automatic data collection may
        include Cookies and Google Analytics - a web analytics service from
        Google Inc. (1600 Amphitheatre Parkway, Mountain View, CA 94043, USA).
      </Typography>
      <Typography component="h4" variant="h4" paragraph>
        CONTACT
      </Typography>
      <Typography paragraph>
        Users contacting UNIQLY and/or providing any personal details do that at
        their own risk and at their own discretion. Personal information of any
        user is stored securely until it has no use or it is no longer required,
        in compliance with GDPR. Any submitted information may be used by us to
        further provide you with information about our products and services or
        to assist you in answering any questions or queries submitted by you.
        This includes using your details to inform you of important
        announcements within website. Regarding receiving any email marketing
        material, we assure you that your details are not passed on to any third
        parties.
      </Typography>
      <Typography component="h4" variant="h4" paragraph>
        EXTERNAL LINKS
      </Typography>
      <Typography paragraph>
        This website will never deliberately include any potentially malicious
        external links on its servers. While we, as UNIQLY, seek to improve your
        overall experience by providing safe and relevant sources, a policy of
        caution should be adopted before clicking on any external links
        referenced by this website. It is for your own safety that you note that
        any external material is entered by you at your own risk and UNIQLY
        cannot be held liable for any damages caused by visiting/interacting
        with any content on external websites.
      </Typography>

      <Typography component="h4" variant="h4" paragraph>
        CHANGES TO PRIVACY POLICY
      </Typography>
      <Typography component="div">
        <ol>
          <li>
            It is our right to revise this Privacy Policy if we feed the need
            to. Any vital change to this Policy will be followed with a
            website-wide notification to all users.
          </li>
          <li>
            The notification shall be made in the form of an email notification
            sent to the Users of our website.
          </li>
          <li>
            Continuing to access or use our website after the revision becomes
            effective is automatically considered a consent to the reviewed
            Policy, and therefore, all users doing so will be bound by it.
          </li>
        </ol>
      </Typography>

      <Typography component="h4" variant="h4" paragraph>
        REVOCATION OF CONSENT TO THE PROCESSING OF PERSONAL DATA
      </Typography>
      <Typography paragraph>
        Many data processing operations are only possible with our Users express
        consent. Our User may revoke consent at any time with future effect. An
        informal email (send to: contact@uniqly.io) making this request is
        sufficient.
      </Typography>
      <Typography paragraph>
        After the expiry of the processing period, Personal data is irreversibly
        deleted or anonymized.
      </Typography>
      <Typography component="h4" variant="h4" paragraph>
        MANAGEMENT AND DELETION OF PERSONAL DATA
      </Typography>
      <Typography paragraph>
        You can exercise the right to protect your Data, resulting from the
        applicable regulations:
      </Typography>
      <Typography component="div">
        <ol>
          <li>
            <b>The right to access and manage your Data:</b>
            <br />
            You have the right to know whether we process information about you:
            specific Personal Data that we have collected about you; the
            categories of Personal Data we have collected about you; categories
            of sources from which your personal data is collected; categories of
            third parties to whom your Personal Data has been disclosed,
            provided that they have been disclosed and the fulfilment of this
            obligation is permitted by law; the nature of the processing of
            Personal Data. You do not need an Account to submit a request for
            viewing/accessing Personal Data. If you submit multiple requests to
            view/access Personal Data, we may charge a fee. You will receive
            information about the amount of the fee before processing your
            request in this regard. We reserve the right to decline a request if
            it is excessive or manifestly unfounded. If we are unable to comply
            with your request, we will let you know the reason. You can also
            exercise your right to correct or update the information you provide
            to us. You can exercise this right and manage your data by directly
            updating your Account or by submitting a request to us. You are
            responsible for the information you provide to us and you should
            keep it accurate and up to date so that we can best deliver Products
            and Services to you. You can also block the use of certain data
            through the settings of your device or browser, which may, however,
            adversely affect your experience with the functionality of
            uniqly.io.
          </li>

          <li>
            <b>The right to remove or limit the processing of your Data:</b>
            <br />
            You have the right to delete some of the Personal Data that you
            provide to us as part of Account registration – if you decide to
            delete the information, we will not be able to provide Services for
            you, including fulfilling orders. You can exercise the right to
            delete data by sending us a request (also if you do not have an
            Account and you have provided us with your data by placing an order
            without registration). In some circumstances, we may retain
            information about you – in order to comply with legal obligations
            (tax, billing, etc.). Some information may remain in backups
            maintained for data integrity and disaster recovery. We make every
            effort to keep your information no longer than necessary and will
            take steps to delete your information where reasonably possible.
          </li>
          <li>
            <b>The right to receive a copy of Personal Data:</b>
            <br />
            You have the right to delete some of the Personal Data that you
            provide to us as part of Account registration – if you decide to
            delete the information, we will not be able to provide Services for
            you, including fulfilling orders. You can exercise the right to
            delete data by sending us a request (also if you do not have an
            Account and you have provided us with your data by placing an order
            without registration). In some circumstances, we may retain
            information about you – in order to comply with legal obligations
            (tax, billing, etc.). Some information may remain in backups
            maintained for data integrity and disaster recovery. We make every
            effort to keep your information no longer than necessary and will
            take steps to delete your information where reasonably possible.
          </li>
          <li>
            <b>The right to receive a copy of Personal Data:</b>
            <br />
            Copies of Personal Data may be sent by electronic means, if
            possible, or by traditional mail. If you submit multiple requests
            for copies of Personal Information, we may charge a fee. You will
            receive information about the amount of the fee before processing
            your request for sending a copy of Personal Data. We reserve the
            right to decline a request if it is excessive or manifestly
            unfounded. We will try to respond to a correct and confirmed request
            for copies of Personal Data as soon as possible.
          </li>
          <li>
            <b>
              The right to cancel or modify consent to marketing communications:
            </b>
            <br />
            You have the right to cancel or modify your consent to receive
            marketing messages. You can exercise this right by logging into your
            Account and changing your communication preferences. Please note
            that this will not affect the lawfulness of data processing prior to
            the withdrawal of consent. You can also withdraw your consent by
            sending us an e-mail containing such a request. Please note that you
            cannot opt out of receiving certain administrative, transactional or
            legal messages that we may send as part of our legitimate business
            if you have a User Account or use certain features available on
            uniqly.io. A complete cessation of sending e-mails is only possible
            if you submit a request to delete your Account.
          </li>
        </ol>
      </Typography>
      <Typography component="h4" variant="h4" paragraph>
        SECURITY
      </Typography>
      <Typography paragraph>
        UNIQLY have implemented several measures to help protect your personal
        information. These measures include, but are not limited to, minimizing
        access to personal data to employees who must have access to it, and
        encrypting personal data transmitted through our websites using the
        SSL/TLS protocol. We update our security measures to increase the
        security of your Personal Data.
      </Typography>
      <Typography paragraph>
        UNIQLY regularly reviews the rules governing the processing of Personal
        Data, including security solutions. UNIQLY have implemented procedures
        for dealing with suspected personal data breaches. The security of your
        Personal Data also depends on you. Be sure to choose an Account password
        that no one else knows or can easily guess, and to keep your login
        details and password confidential. When finished, log out of your
        Account, especially if you are using a shared computer.
      </Typography>
      <Typography paragraph>
        UNIQLY is not responsible for the actions of unauthorized persons to
        whom login details have been disclosed. In such cases, we are not
        responsible for any acquisition or distribution of your Personal Data by
        such unauthorized party. If you believe that your personal information
        has been compromised, we encourage you to notify us immediately.
      </Typography>
      <Typography component="h4" variant="h4" paragraph>
        RIGHT TO FILE A COMPLAIN
      </Typography>
      <Typography>
        <b>LAST UPDATED: </b>
        27.03.2024
      </Typography>
    </Layout>
  );
};

export default PrivacyPage;
